<template>
  <div class="pt-24">
    <h4 class="mb-22 txt-40 txt-black txt-bold txt-font-din-medium">
      {{ $t('components.titles.mortalityAndDemography') }}
    </h4>
    <a-tabs :default-active-key="activeTab" size="large" @change="onTabChange">
      <a-tab-pane key="results">
        <div slot="tab" data-cy="results-mortality-results-tab" class="txt-black txt-font-din-medium">{{ $t('components.titles.results').toUpperCase() }}</div>
        <MortalityResults/>
      </a-tab-pane>
      <a-tab-pane key="dataentry" :disabled="!surveyId">
        <div slot="tab" data-cy="results-mortality-data-entry-tab" class="txt-black txt-font-din-medium">{{ $t('components.titles.dataEntry').toUpperCase() }}</div>
        <MortalityNormalizedDataEntry
          :disable-clusters="isRandom || isExhaustive"
          :on-entry-change="onEntryChange"/>
      </a-tab-pane>
      <a-tab-pane key="settings" :disabled="!surveyId || !settingsLoaded">
        <div slot="tab" data-cy="results-mortality-settings-tab" class="txt-black txt-font-din-medium">{{ $t('components.titles.settings').toUpperCase() }}</div>
        <MortalitySettings/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import project from '../../../mixins/project';
import MortalityResults from './Results/results.vue';

export default {
  name: 'Mortality',
  components: {
    MortalityResults,
    MortalityNormalizedDataEntry: () => import('./NormalizedDataEntry/data-entry'),
    MortalitySettings: () => import('./Settings/settings')
  },
  mixins: [project()],
  props: {
    activeTab: {
      type: String,
      default: 'results'
    }
  },
  data() {
    return {
      changed: false
    };
  },
  computed: {
    ...mapGetters(['isRandom', 'isExhaustive', 'mortalitySettingsChanged']),
    ...mapState({
      surveyId: state => state.survey.surveyId,
      projectId: state => state.survey.project.id,
      settingsLoaded: state => state.results.mortalitySettingsLoaded,
      isFetching: state => state.results.fetchingData
    })
  },
  watch: {
    surveyId: {
      deep: true,
      handler() {
        if (this.surveyId) {
          this.onData();
        }
      }
    },
    mortalitySettingsChanged() {
      if (this.mortalitySettingsChanged) {
        this.onDataChange();
        this.markMortalitySettingsChanged();
      }
    },
    isFetching(newVal, oldVal) {
      const key = 'mortality_analysis';
      if (newVal) {
        this.$message.loading({ content: this.$t('components.notifications.calculatingAnalysis'), duration: 3, key });
      } else {
        this.$message.success({ content: this.$t('components.notifications.mortalityAnalysisComplete'), key, duration: 2 });
      }
    }
  },
  mounted() {
    if (this.surveyId) {
      this.onData();
    }
  },
  methods: {
    ...mapActions([
      'getMortalitySubmissionData',
      'getMortalitySettings',
      'getMortalityAnalysis',
      'markMortalitySettingsChanged'
    ]),
    onTabChange(newActive) {
      if (this.changed) {
        this.onDataChange();
        this.changed = false;
      }
      const route = { name: 'Mortality & Demography', params: { activeTab: newActive } };
      this.$router.replace(route);
    },
    onEntryChange() {
      this.changed = true;
    },
    onDataChange() {
      this.getMortalityAnalysis({ surveyId: this.surveyId, projectId: this.projectId });
    },
    onData() {
      this.getMortalitySubmissionData({
        projectId: this.projectId,
        surveyId: this.surveyId
      });
      this.getMortalitySettings({ surveyId: this.surveyId, projectId: this.projectId });
      this.getMortalityAnalysis({ surveyId: this.surveyId, projectId: this.projectId });
    }
  }
};
</script>

<style lang="scss">
</style>
